{
  "name": "@spectrumnodes/sdk",
  "version": "2.0.0",
  "description": "Official TypeScript SDK for the Spectrum Nodes API — blocks, gas, balances, tokens, DeFi yields, and JSON-RPC across 18+ chains.",
  "type": "module",
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "import": {
        "types": "./dist/index.d.ts",
        "default": "./dist/index.js"
      },
      "require": {
        "types": "./dist/index.d.cts",
        "default": "./dist/index.cjs"
      }
    }
  },
  "files": [
    "dist",
    "examples",
    "docs",
    "README.md",
    "LICENSE"
  ],
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "prepare": "husky",
    "test": "vitest run",
    "test:coverage": "vitest run --coverage",
    "test:integration": "tsx integration-tests/run.ts",
    "test:mutation": "stryker run",
    "test:mutation:dry": "stryker run --dryRunOnly",
    "test:watch": "vitest",
    "typecheck": "tsc --noEmit",
    "lint": "./node_modules/eslint/bin/eslint.js .",
    "dupcheck": "jscpd --config .jscpd.json",
    "clean": "rm -rf dist",
    "prepublishOnly": "npm run build"
  },
  "keywords": [
    "spectrum",
    "blockchain",
    "api",
    "sdk",
    "ethereum",
    "solana",
    "bitcoin",
    "cosmos",
    "defi",
    "web3",
    "rpc",
    "multi-chain",
    "typescript"
  ],
  "author": "Spectrum Nodes",
  "license": "MIT",
  "devDependencies": {
    "@eslint/js": "9.39.4",
    "@spectrum-nodes/api-spec": "file:../spectrum-api-spec",
    "@stryker-mutator/core": "9.6.1",
    "@stryker-mutator/typescript-checker": "9.6.1",
    "@stryker-mutator/vitest-runner": "9.6.1",
    "@typescript-eslint/eslint-plugin": "8.59.1",
    "@typescript-eslint/parser": "8.59.1",
    "@vitest/coverage-v8": "^4.1.9",
    "eslint": "9.39.4",
    "globals": "16.5.0",
    "husky": "9.1.7",
    "jscpd": "4.0.9",
    "tsup": "8.5.1",
    "tsx": "4.21.0",
    "typescript": "5.9.3",
    "typescript-eslint": "8.59.1",
    "vite": "6.3.5",
    "vitest": "^4.1.9"
  },
  "dependencies": {
    "ethers": "^6.17.0",
    "zod": "4.3.6"
  }
}
